import { Grid } from "@mui/material";
import React from "react";

import PatientList from "./PatientsList";

const Patients = () => {
  return (
    <Grid container maxWidth="xl" mb={3}>
      <Grid container gap={1} mt={2} justifyContent={"center"}>
        <Grid item xs={12} lg={12}>
          <PatientList />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Patients;
